<template>
  <section>
    <section class="related-field" v-if="fieldData.length">
      <!-- 標題 -->
      <h2 class="related-field__title">{{ titleImage.alt }}</h2>
      <!-- 相片、圖鑑集 -->
      <AlbumCollection
        v-if="displayType === 'album'"
        :coverings="fieldData"
        :displayType="displayType"
        :hasFavourite="hasFavourite"
      >
        <template v-slot:title="album">
          <!-- 銜接相簿的標題，album 是 slotProp -->
          <h3>{{ album.cover.title }}</h3>
        </template>
        <slot name="moreArticles"></slot>
      </AlbumCollection>
      <!-- 卡片 -->
      <HeroCards
        :cards="fieldData"
        :linkPath="linkPath"
        :hasFavourite="hasFavourite"
        v-else
      >
        <slot name="moreArticles"></slot>
      </HeroCards>
      <!-- 查看更多文章 -->
    </section>
    <section class="related-field__no-data" v-else v-show="hasEmptyPage">
      目前{{ titleImage.alt }}沒有文章
    </section>
  </section>
</template>

<script>
import HeroCards from '@/components/HeroCards';
import AlbumCollection from '@/components/AlbumCollection';

export default {
  name: 'ArticleRelatedField',
  props: {
    displayType: {
      type: String,
      default: '',
    },
    linkPath: {
      type: String,
      default: '',
    },
    titleImage: {
      type: Object,
      default: () => {
        return { src: '123.png', alt: '圖鑑集' };
      },
    },
    fieldData: {
      type: Array,
      default: () => [],
    },
    hasEmptyPage: {
      type: Boolean,
      default: false,
    },
    hasFavourite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getTwoPhotosOfAlbum: function(album) {
      return album.slice(0, 2);
    },
  },
  components: {
    HeroCards,
    AlbumCollection,
  },
};
</script>

<style lang="scss" scoped>
.related-field {
  position: relative;
  margin-bottom: 55px;

  @include for-tablet {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  &__title {
    /* 首頁卡片標題 */
    font-family: $title-font-family;
    font-weight: 600;
    font-size: 1.75rem;
    letter-spacing: 2px;
    text-align: center;
    color: $color-light-title;
    margin: 20px 0;
    @include truncate-string(100%);
  }

  a {
    display: inline-block;
  }

  h3 {
    position: relative;
    font-size: 1.375rem;
    letter-spacing: 1.22px;
    margin: 0 auto 15px;
    width: 280px;
    color: $color-light-title;
    font-weight: 500;
    padding: 12px 0;
    text-align: left;
  }

  &__field {
    margin-bottom: 20px;
  }
  @keyframes fadein {
    from {
      color: transparent;
      opacity: 0;
    }
    to {
      color: $color-light-title;
      opacity: 1;
    }
  }
  &__no-data {
    font-size: 1.5rem;
    margin-bottom: 50px;
    font-family: $text-font-family;
    color: transparent;
    animation: 1s linear 1s 1 fadein;
    animation-fill-mode: forwards;
  }
}
</style>
